import React from 'react';
import proptypes from 'prop-types';
const { node, shape } = proptypes;
import { AppContext } from './AppContext';

const AppProvider = ({ children, instance }) => {

  const value = {
    instance
  };
  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
};

AppProvider.propTypes = {
  children: node.isRequired,
  instance: shape({}).isRequired
};

export { AppProvider };
